import { pipe } from 'fp-ts/lib/function';
import * as O from 'fp-ts/Option';
import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { Head } from '../../components/Head';
import { sequenceTOption } from '../../function';

import { useMatchActivityQuery } from '../../generated/graphql';
import { NotFound } from '../NotFound';
import { ActivityHome } from './ActivityHome';

interface Props extends RouteComponentProps<{ id: string }> {}

export const MatchActivity: React.FC<Props> = ({
  match: {
    params: { id },
  },
}) => {
  const [activityRes] = useMatchActivityQuery({ variables: { id } });
  const activity = activityRes.data?.matchActivity;

  if (activity) {
    const [title, description] = pipe(
      sequenceTOption(
        O.fromNullable(activity.player),
        O.fromNullable(activity.match),
      ),
      O.map(([player, match]): [string, string] => {
        return [
          `Matchhaus - ${player.name}'s performance vs ${match.opponent}`,
          `${player.name}'s match performance against ${match.opponent} including their position heatmap and key running stats.`,
        ];
      }),
      O.getOrElse<[string, string]>(() => [
        `Matchhaus - Player performance`,
        "Match performance including the player's position heatmap and key running stats.",
      ]),
    );
    const image = `${window.location.protocol}//${window.location.host}/assets/og-image.png`;
    return (
      <>
        <Head>
          <meta property="og:type" content="website" />
          <meta property="og:site_name" content="Matchhaus" />
          <meta property="og:title" content={title} />
          <meta property="og:description" content={description} />
          <meta property="og:image" content={image} />

          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:image:src" content={image} />
          <meta name="twitter:title" content={title} />
        </Head>
        <ActivityHome activity={activity} />
      </>
    );
  }

  if (activityRes.fetching) {
    return null;
  }

  return <NotFound />;
};
